import React from 'react'
import PropTypes from 'prop-types'
import { without, union } from 'ramda'

import Checkbox from '../../../../components/Checkbox'

import './styles.css';

// util functions

const uncheck = (value, options, selected) => {
    if (hasSubOptions(value, options)) {
        const subOptions = options
            .find(option => option.id === value)
            .subOptions.map(subOption => subOption.id)

        return without([value, ...subOptions], selected)
    }

    if (isSubOption(value, options) && shouldUncheckParent(value, options, selected)) {
        return without([value, getParent(value, options)], selected)
    }

    return without([value], selected)
}

const check = (value, options, selected) => {
    if (hasSubOptions(value, options)) {
        const subOptions = options
            .find(option => option.id === value)
            .subOptions.map(subOption => subOption.id)

        return union([value, ...subOptions], selected)
    }

    if (isSubOption(value, options)) {
        return union([value, getParent(value, options)], selected)
    }

    return union([value], selected)
}

const isSubOption = (value, options) => {
    return options
        .find(option => {
            return option.subOptions && option.subOptions.find(subOption => subOption.id === value)
        }) ?
        true :
        false
}

const hasSubOptions = (value, options) => {
    const option = options.find(opt => opt.id === value)
    return option && option.subOptions && option.subOptions.length > 0
}

const shouldUncheckParent = (value, options, selected) => {
    return options
        .find(option => {
            if (option.subOptions && option.subOptions.find(subOption => subOption.id === value)) {
                return option.subOptions.reduce((selectedCount, subOption) => {
                    return selectedCount += selected.find(sel => sel === subOption.id) ? 1 : 0
                }, 0) > 1 ? false : true
            }
            return false
        }) ?
        true :
        false
}

const getParent = (value, options) => {
    const parent = options.find(option => {
        return option.subOptions && option.subOptions.find(subOption => subOption.id === value)
    })

    return parent ? parent.id : undefined
}

// component

function CheckboxGroup({ label, options, input, limitOptionsHeight, ...props }) {

    const _onChange = (checkbox) => {
        if (checkbox.checked) {
            input.onChange(check(checkbox.value, options, input.value))
        }
        else {
            input.onChange(uncheck(checkbox.value, options, input.value))
        }
    }

    return (
        <div
            className={`CheckboxGroup${(limitOptionsHeight ? ' CheckboxGroup--limit-options-height': '')}`}
            {...props}
        >
            <div className="CheckboxGroup__label">{label}</div>
            <div className="CheckboxGroup__options-container">
            {
                options.map(option => {
                    const isChecked = input.value.find(value => option.id === value) ? true : false
                    const subOptions = option.subOptions;
                    return (
                        <div
                            key={option.id}
                            className="CheckboxGroup__option"
                        >
                            <Checkbox
                                id={"checkbox-group-option-" + option.id}
                                name={"checkbox-group-option-" + option.id}
                                value={option.id}
                                label={option.label}
                                isChecked={isChecked}
                                onClick={_onChange}
                            />
                            <div className="CheckboxGroup__sub-options">
                            {
                                subOptions && subOptions.map(subOption => {
                                    const isChecked = input.value.find(value => subOption.id === value) ? true : false
                                    return (
                                        <div
                                            key={subOption.id}
                                        >
                                            <Checkbox
                                                id={"checkbox-group-sub-option-" + subOption.id}
                                                name={"checkbox-group-sub-option-" + subOption.id}
                                                value={subOption.id}
                                                label={subOption.label}
                                                isChecked={isChecked}
                                                onClick={_onChange}
                                            />
                                        </div>
                                    )
                                })
                            }
                            </div>
                        </div>
                    )
                })
            }
            </div>
        </div>
    )
}

CheckboxGroup.propTypes = {
    label: PropTypes.string,
    options: PropTypes.array.isRequired,
    input: PropTypes.object
};

export default CheckboxGroup;